import { render, staticRenderFns } from "./shopMobTop.vue?vue&type=template&id=a823f1b8&"
import script from "./shopMobTop.vue?vue&type=script&lang=js&"
export * from "./shopMobTop.vue?vue&type=script&lang=js&"
import style0 from "./shopMobTop.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports